import { render } from "./BannerSection.vue?vue&type=template&id=8ee57bf4&scoped=true"
const script = {}

import "../../assets/css/home.css?vue&type=style&index=0&id=8ee57bf4&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ee57bf4"]])

export default __exports__